import * as React from 'react';
import type { SVGProps } from 'react';
const SvgButtonPlusIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <rect width={2.857} height={20} x={8.571} fill="#fff" rx={1.429} />
    <rect
      width={2.857}
      height={20}
      x={20}
      y={8.571}
      fill="#fff"
      rx={1.429}
      transform="rotate(90 20 8.571)"
    />
  </svg>
);
export default SvgButtonPlusIcon;
